export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_MB_EQS.ef038ffd.jpg";